import { useCallback, useMemo } from "react";

import { createCastleAdapter } from "@func-core/core/data/adapters";

type UseCastleTokenResult = {
  generateToken: () => Promise<string | null>;
};

export const useCastleToken = (): UseCastleTokenResult => {
  const castleAdapter = useMemo(() => createCastleAdapter(), []);

  const generateToken = useCallback(async (): Promise<string | null> => {
    return castleAdapter.createRequestToken();
  }, [castleAdapter]);

  return { generateToken };
};
